const Spinner = () => <div className="lds-ripple"><div></div><div></div></div>;

export default Spinner;